import { useState } from "react";

export const useAlert = () => {
  const [messageError, setMessageError] = useState<string | null>(null);
  const [messageSuccess, setMessageSuccess] = useState<string | null>(null);

  const unsetMessages = () => {
    setMessageError(null);
    setMessageSuccess(null);
  };

  return {
    messageError,
    setMessageError: (val: string | null) => {
      setMessageError(val);
      setMessageSuccess(null);
    },
    messageSuccess,
    setMessageSuccess: (val: string | null) => {
      setMessageSuccess(val);
      setMessageError(null);
    },
    unsetMessages
  };
};
